import React, { useState, useEffect } from 'react';
import { EnableBadge, DisableBadge } from '../Res/BaseButton';

export function ContentBox({ id="", superTitle = "", title, dangerTitle = "", hasTitle = true, enableCount, enableText, disableCount, disableText, otherButton, title_tools
  , hasDrawer = false, defaultHideDrawer, content, footer, titleSize = 3 }) {

  const [isHide, setHide] = useState(defaultHideDrawer !== undefined ? defaultHideDrawer : false)

  function changeHide() {
    setHide(!isHide)
  }

  var enableBadge = (enableCount === undefined) ? <></> : <EnableBadge count={enableCount} text={enableText} />
  var disableBadge = (disableCount === undefined) ? <></> : <DisableBadge count={disableCount} text={disableText} />

  var drawer = <></>
  if (hasDrawer) {
    drawer =
      <a href="#A" className="collapse-link" onClick={e => changeHide()}>
        {isHide ?
          <i className="fa fa-chevron-up"></i>
          : <i className="fa fa-chevron-down"></i>
        }
      </a>
  }

  var displayStyle = isHide ? { display: "none" } : { display: "block" }

  var titleContent = !hasTitle ? <></> :
    <div className="ibox-title" style={{paddingLeft:"0"}}>
      <div className={"col-sm-" + titleSize}>
        <h5>
          <span className="text-success">{superTitle}&nbsp;</span>
          <span className="text-primary">{title}</span>
        </h5>
        <span className="text-danger">{dangerTitle}</span>
      </div>
      {enableBadge}
      {disableBadge}
      {otherButton}
      <div className="ibox-tools">
        {title_tools}
        {drawer}
      </div>
    </div>

  var flotterContent = footer === undefined ? <></> :
    <div className="ibox-footer">
      {footer}
    </div>

  return (

    <div className="row" id={id}>
      <div className="col-lg-12">
        <div className="ibox m-b-sm">
          {titleContent}
          <div className="ibox-content" style={displayStyle}>
            {content}
          </div>
          {flotterContent}
        </div>
      </div>
    </div>
  )
}